import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  StationOrLocationItem,
  GuidIdCodeAndLabel,
  CodeAndLabel,
  TechLogsValidationData,
  BrandAndMarketListItem,
  Int32IdAndLabel,
} from "../../../integrated-client/models";
import { IAutocompleteObject } from "../../../store/state/SearchManager/FormData";

dayjs.extend(utc);

export interface IStoreLeg {
  departure?: StationOrLocationItem | null;
  destination?: StationOrLocationItem | null;
  departureDate?: string;
  cabin?: string | null;
}

export type Legs = Array<IStoreLeg> | null;

export interface IFormRequestData {
  legs: Legs;
  directFlightsOnly: boolean;
  preferredCarriers: Array<GuidIdCodeAndLabel> | null;
  fareTypes: Array<string> | null;
  maxConnectionTime: string | null;
  excludeBaglessFares: boolean;
}

export class FormRequestData {
  legs: Legs;
  directFlightsOnly: boolean;
  preferredCarriers: Array<GuidIdCodeAndLabel> | null;
  fareTypes: Array<string> | null;
  maxConnectionTime: string | null;
  excludeBaglessFares: boolean;

  constructor() {
    this.legs = null;
    this.directFlightsOnly = false;
    this.preferredCarriers = null;
    this.fareTypes = ["Published", "Private", "Itx", "Tim"];
    this.maxConnectionTime = null;
    this.excludeBaglessFares = false;
  }
}

export interface IIdentity {
  brandAndMarket: BrandAndMarketListItem | null;
  channel: Int32IdAndLabel | null;
  agency: IAutocompleteObject | null;
  salesJourney: CodeAndLabel | null;
  accountCode: string | null;
  passengerAges: Array<number> | null;
}

export class Identity implements IIdentity {
  brandAndMarket: BrandAndMarketListItem | null;
  channel: Int32IdAndLabel | null;
  agency: IAutocompleteObject | null;
  salesJourney: CodeAndLabel | null;
  accountCode: string | null;
  passengerAges: Array<number> | null;

  constructor(salesJourney?: CodeAndLabel | null) {
    this.brandAndMarket = null;
    this.channel = null;
    this.agency = null;
    this.salesJourney = salesJourney || null;
    this.accountCode = null;
    this.passengerAges = null;
  }
}

export interface IFormDataLive {
  availabilityRequest: IFormRequestData;
  simulatedInstant: string | null;
  identity: IIdentity;
  validation?: any;
  validationIdentity?: any;
  historicalValidation: TechLogsValidationData | null;
  correlationId: string | null;
}

export class FormData implements IFormDataLive {
  availabilityRequest: IFormRequestData;
  simulatedInstant: string | null;
  identity: IIdentity;
  validation?: any;
  validationIdentity?: any;
  historicalValidation: TechLogsValidationData | null;
  correlationId: string | null;

  constructor(salesJourney?: CodeAndLabel | null) {
    this.availabilityRequest = new FormRequestData();
    this.simulatedInstant = dayjs.utc().toISOString();
    this.identity = new Identity(salesJourney);
    this.correlationId = null;
    this.historicalValidation = null;
  }
}
